class InputNumber {
    constructor(element) {
        this.element = element;
        this.groupNumber = (this.element) ? this.element.nextElementSibling : null;
        this.increaseButton = (this.groupNumber) ? this.groupNumber.children[0] : null;
        this.decreaseButton = (this.groupNumber) ? this.groupNumber.children[1] : null;
        this.step = (this.element) ? parseFloat(this.element.getAttribute('step')) : 1;
        this.step = (isNaN(this.step)) ? 1 : this.step;
        this.min = (this.element) ? parseFloat(this.element.getAttribute('min')) : null;
        this.max = (this.element) ? parseFloat(this.element.getAttribute('max')) : null;
        this.init();
    }

    attachListeners() {
        const getMaxDecimalPlaces = (num) => {
            const parts = num.toString().split('.');
            return parts[1] ? parts[1].length : 0;
        };
        if (this.increaseButton) {
            let interval;
            const maxDecimalPlaces = getMaxDecimalPlaces(this.step);

            const startIncreasing = () => {
                interval = setInterval(() => {
                    let currentValue = parseFloat(this.element.value);
                    if (isNaN(currentValue)) {
                        currentValue = 0;
                    }
                    const newValue = (currentValue + this.step).toFixed(maxDecimalPlaces);
                    this.element.value = newValue.includes('.') ? newValue.replace(/\.?0+$/, '') : newValue;
                    if (this.max !== null && parseFloat(this.element.value) > this.max) {
                        this.element.value = this.max;
                    }
                }, 65);
            };
            const stopIncreasing = () => {
                clearInterval(interval);
            };

            this.increaseButton.addEventListener('mousedown', startIncreasing);
            this.increaseButton.addEventListener('mouseup', stopIncreasing);
            this.increaseButton.addEventListener('mouseleave', stopIncreasing);
            this.increaseButton.addEventListener('touchstart', startIncreasing);
            this.increaseButton.addEventListener('touchend', stopIncreasing);
        }
        if (this.decreaseButton) {
            let interval;
            const maxDecimalPlaces = getMaxDecimalPlaces(this.step);

            const startDecreasing = () => {
                interval = setInterval(() => {
                    let currentValue = parseFloat(this.element.value);
                    if (isNaN(currentValue)) {
                        currentValue = 0;
                    }
                    const newValue = (currentValue - this.step).toFixed(maxDecimalPlaces);
                    this.element.value = newValue.includes('.') ? newValue.replace(/\.?0+$/, '') : newValue;
                    if (this.min !== null && parseFloat(this.element.value) < this.min) {
                        this.element.value = this.min;
                    }
                }, 65);
            };
            const stopDecreasing = () => {
                clearInterval(interval);
            };

            this.decreaseButton.addEventListener('mousedown', startDecreasing);
            this.decreaseButton.addEventListener('mouseup', stopDecreasing);
            this.decreaseButton.addEventListener('mouseleave', stopDecreasing);
            this.decreaseButton.addEventListener('touchstart', startDecreasing);
            this.decreaseButton.addEventListener('touchend', stopDecreasing);
        }
    }

    value() {
        return this.element.value;
    }

    val() {
        return this.value();
    }

    init() {
        this.attachListeners();
    }
}

// Inisialisasi class setelah DOM siap
document.addEventListener('DOMContentLoaded', () => {
    new InputNumber();
});

export default InputNumber;